import { render, staticRenderFns } from "./OrderStateList.vue?vue&type=template&id=5ede27d8&"
import script from "./OrderStateList.vue?vue&type=script&lang=js&"
export * from "./OrderStateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports